export enum EntityType {
  User = 'User',
  Invitation = 'Invitation',
  Tag = 'Tag',
  Workflow = 'Workflow',
  Metadata = 'Metadata',
  Variant = 'Variant',
  Asset = 'Asset',
  Duplicate = 'Duplicate',
  NodeShare = 'NodeShare',
  Share = 'Share',
  Destination = 'Destination',
  Trash = 'Trash',
  Ingestion = 'Ingestion',
}
